module.exports = __webpack_public_path__ + "f40ad763e422980b3f93e69848cba4a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/en/phoenixwar.jpg
// module id = 244
// module chunks = 30